import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import Swal from "sweetalert2"
import { Alert, Button, Col, Container, Row } from "reactstrap"
import { Formik } from "formik"
import { useLocation } from "react-router-dom"
import { Loading } from "components"
import storage from "services/storage"
import { authUserKey } from "config/API"
import { PendingPaidSales } from "components/sales"
import { ModalPeriodicTask, ModalCashRetreat } from "pages/PeriodicTasks"
import { getLimitForCashCut } from "services/periodic-tasks"
import { isNewTickets, getCashCounterRegister } from "services/tickets"
import { useQuery } from "@tanstack/react-query"
import { getCurrentCashOperationDay } from "services/cash-operation-days"

import OutPaiding from "components/sales/popOutPaiding"

function TicketForm() {
  const { user_permissions: permissions } = storage.get(authUserKey)
  const location = useLocation()
  const isLoading = permissions.isLoading
  const dataForm = useRef()
  const lastCheckedTicketCountRef = useRef(null)
  const lastCheckedSearchRef = useRef("")
  const [isOutPaidingModalOpen, setIsOutPaidingModalOpen] = useState(false)

  const [ticketPaying, setTicketPaying] = useState(null)
  const [textSerch, setTextSerch] = useState("")
  const [, setNumItems] = useState()
  const [newInfor, setNewInfor] = useState(false)

  const checkNewTicket = async (textSerchh) => {
    const response = await isNewTickets({ search: textSerchh })
    const newTicketCount = Number(response?.data?.count || response?.data?.results?.length || 0)

    if (lastCheckedSearchRef.current !== textSerchh) {
      lastCheckedSearchRef.current = textSerchh
      lastCheckedTicketCountRef.current = newTicketCount
      return
    }

    const previousTicketCount = lastCheckedTicketCountRef.current
    lastCheckedTicketCountRef.current = newTicketCount

    if (previousTicketCount !== null && newTicketCount > previousTicketCount) {
      setNewInfor(true)
    }
  }

  useEffect(() => {
    const intervalo = setInterval(() => {
      checkNewTicket(textSerch)
    }, 3000) // cada 5 segundos

    return () => clearInterval(intervalo) // limpieza al desmontar
  }, [textSerch])

  useEffect(() => {
    if (ticketPaying) {
      setIsOutPaidingModalOpen(true)
    }
  }, [ticketPaying])

  const renderLoading = () => {
    return (
      <div className="text-center">
        <Loading isLoading={isLoading} size={2} />
      </div>
    )
  }

  const renderError = () => {
    return (
      <div className="text-center">
        <Alert color="danger" isOpen={permissions.isError}>
          {permissions?.error?.errors?.map((error) => error?.message)}
        </Alert>
      </div>
    )
  }

  const [modalCashCut, setmodalCashCut] = useState(false)
  const toggleModalCashCut = () => {
    setmodalCashCut(!modalCashCut)
  }
  const canAdd = permissions.some((e) => e.codename === "add_cashcut")

  const [cashRetreat, setCashRetreat] = useState(false)
  const toggleCashRetreat = () => {
    setCashRetreat(!cashRetreat)
  }
  const [limitCash, setLimitCash] = useState()
  const [cashInRegister, setCcashInRegister] = useState()
  const [, setColorButton] = useState("success")
  const [FinishSold, setFinishSold] = useState(false)
  const initialSalesTab = new URLSearchParams(location.search).get("tab") === "cash" ? "cash" : "sales"
  const cashOperationDayQuery = useQuery(["cash-operation-day-current"], () => getCurrentCashOperationDay(), {
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchInterval: 5000,
    staleTime: 0,
  })

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tab = params.get("tab")

    if (tab === "cash") {
      params.delete("tab")
      const nextSearch = params.toString()
      window.history.replaceState({}, "", `${location.pathname}${nextSearch ? `?${nextSearch}` : ""}`)
    }
  }, [location.pathname, location.search])

  useEffect(() => {
    getLimitForCashCut().then((limit) => {
      setLimitCash(Number(limit.results[0].limit))
    })

    getCashCounterRegister().then((cashRegister) => {
      setCcashInRegister(Number(cashRegister.cash))
    })
    const cashPersent = cashInRegister / limitCash
    if (cashPersent >= 0.8 && cashPersent < 0.95) {
      setColorButton("warning")
    } else {
      setColorButton("success")
    }
    if (cashPersent >= 0.95 && cashPersent < 1) {
      setColorButton("danger")
      if (!isOutPaidingModalOpen && !cashRetreat && !modalCashCut) {
        Swal.fire({
          title: "Estas cerca del limite de efectivo",
          text: "Retire efectivo para evitar contratiempos",
          icon: "warning",
          confirmButtonColor: "#6fc33a",
        })
      }
    }
    if (cashPersent >= 1) {
      setColorButton("dark")
      if (!isOutPaidingModalOpen && !cashRetreat && !modalCashCut) {
        Swal.fire({
          title: "Limite de efectivo alcanzado",
          text: "Retire dinero en caja para poder seguir cobrando en efectivo",
          icon: "error",
          confirmButtonColor: "#6fc33a",
        })
      }
    }
    setFinishSold(false)
  }, [modalCashCut, limitCash, cashInRegister, FinishSold])
  useEffect(() => {
    getCashCounterRegister().then((cashRegister) => {
      setCcashInRegister(Number(cashRegister.cash))
    })
  }, [cashRetreat])

  document.title = "Generar Ticket | Punto de venta"
  return (
    <React.Fragment>
      {canAdd && <ModalPeriodicTask isOpen={modalCashCut} toggle={toggleModalCashCut} />}
      {canAdd && <ModalCashRetreat isOpen={cashRetreat} toggle={toggleCashRetreat} />}
      {isLoading && renderLoading()}
      {!isLoading && permissions.isError && renderError()}
      {!isLoading && !permissions.isError && (
        <Formik enableReinitialize initialValues={dataForm.current || {}}>
          {() => (
            <div className="page-content">
              <Container fluid>
                <Row>
                  <Col>
                    <h2>Cuenta del día</h2>
                  </Col>
                  {/* <Col className="d-flex center pb-2">
                    <Button color={colorButton} className="d-flex align-items-center me-2" onClick={toggleCashRetreat}>
                      <i className="me-2 fa fa-coins " />
                      <span className="text-truncate">Retiro de efectivo</span>
                    </Button>
                  </Col> */}
                  <Col className="d-flex justify-content-end pb-2">
                    <Button color="success" className="d-flex align-items-center me-2" onClick={toggleModalCashCut}>
                      <i className="me-2 fa fa-clipboard-check" />
                      <span className="text-truncate">Corte de caja manual</span>
                    </Button>
                  </Col>
                </Row>
                <div className="bg-white p-3">
                  <PendingPaidSales
                    initialActiveTab={initialSalesTab}
                    setTicketPaying={setTicketPaying}
                    textSerch={setTextSerch}
                    numItems={setNumItems}
                    newInfor={newInfor}
                    setNewInfor={setNewInfor}
                    isCashOperationDayOpen={Boolean(cashOperationDayQuery.data)}
                  />
                  {ticketPaying && (
                    <OutPaiding
                      isOpen={isOutPaidingModalOpen}
                      setFinishSold={setFinishSold}
                      toggleModal={() => {
                        setIsOutPaidingModalOpen(!isOutPaidingModalOpen)
                        setTicketPaying(null)
                      }}
                      ticketPaying={ticketPaying}
                    />
                  )}
                </div>
              </Container>
            </div>
          )}
        </Formik>
      )}
    </React.Fragment>
  )
}

TicketForm.propTypes = {
  isCreate: PropTypes.bool,
  submit: PropTypes.func,
  data: PropTypes.object,
  toggle: PropTypes.func,
  isLoadingSubmit: PropTypes.bool,
  isError: PropTypes.bool,
  error: PropTypes.object,
}

export default TicketForm
